<template>
    <div>
        <div class="uk-grid">
            <div class="uk-width-4-5">
                <h2>Prospective Projects</h2>
            </div>
            <div class="uk-width-1-5 uk-text-right">
                <div class="uk-button-group lam-graph-filter">
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.projects_scope === 'weeks'}"
                        @click.prevent="$emit('set-state-value', 'projects_scope', 'weeks')"
                    >
                        6 weeks
                    </base-button>
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.projects_scope === 'months'}"
                        @click.prevent="$emit('set-state-value', 'projects_scope', 'months')"
                    >
                        6 months
                    </base-button>
                </div>
            </div>
        </div>
        <cards
            id="prospectives-dashboard-prospective-projects"
            :cards="cards"
            :selectable="false"
            :flex="true"
        >
            <template slot="card" slot-scope="props">
                <div v-if="props.card.id === 'prospective-statii'">
                    <prospective-statii
                        :dataset-id="props.card.id"
                        :raw-data="dataset['projects']"
                        :filter="state.projects_scope"
                        style="max-height: 270px;"
                    />
                </div>
                <div v-else-if="props.card.id === 'proposal-hit-rate'">
                    <proposal-hit-rate
                        :dataset-id="props.card.id"
                        :raw-data="dataset['proposals']"
                        :filter="state.projects_scope"
                        style="max-height: 270px;"
                    />
                </div>
            </template>
        </cards>
    </div>
</template>

<script type="text/javascript">
// import uses_color_palette from "../../../mixins/UsesColorPalette"

import Cards from "../../../ui/Cards"
import BaseButton from "../../../ui/BaseButton"
import ProspectiveStatii from "../../dashboard/Graphs/ProspectiveStatii"
import ProposalHitRate from "../../dashboard/Graphs/ProposalHitRate"

export default {
    components: {
        Cards,
        BaseButton,
        ProspectiveStatii,
        ProposalHitRate
    },
    computed: {
        fields () {
            return ["ns::project;fieldset::graph"]
        },
        cards () {
            const cards = [
                {
                    id: "prospective-statii",
                    title: "By Status",
                    classes: { "lam-card-list-graph": true, "uk-width-small-1-1": true, "uk-width-large-1-3": true }
                },
                {
                    id: "proposal-hit-rate",
                    title: "Proposal Hit Rate",
                    classes: { "lam-card-list-graph": true, "uk-width-small-1-1": true, "uk-width-large-2-3": true }
                }
            ]

            return cards
        }
    },
    props: {
        dataset: {
            required: true
        },
        state: {
            required: true
        }
    },
    data () {
        return {
        }
    }
}
</script>
